module.exports = __webpack_public_path__ + "static/img/kaprow-hover.896731c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kaprow-hover.jpg
// module id = g8so
// module chunks = 0